"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7958],{

/***/ 37958:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ln": function() { return /* binding */ GetBalanceNftInMarket; },
/* harmony export */   "cI": function() { return /* binding */ GetDataUser; },
/* harmony export */   "ee": function() { return /* binding */ GetTotalBoxUserBuy; },
/* harmony export */   "km": function() { return /* binding */ GetMaxNftTransfer; },
/* harmony export */   "vq": function() { return /* binding */ GetBoxBuyOfUser; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(97582);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9473);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87057);
/* harmony import */ var _actions__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10296);






var GetBalanceNftInMarket = function(chainId) {
    var marketMultiBuy = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(function(state) {
        return state.marketMultiBuy;
    });
    var nftInfo = marketMultiBuy.nftInfo;
    var nftBalance = nftInfo.nftBalance;
    var nftPrice = nftInfo.nftPrice;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useDispatch */ .I0)();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var getNftBalanceInMarket = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
                var result, e;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                (0,___WEBPACK_IMPORTED_MODULE_2__/* .fetchBalanceNftInMarkeMultiBuy */ .Ae)(chainId)
                            ];
                        case 1:
                            result = _state.sent();
                            dispatch((0,_actions__WEBPACK_IMPORTED_MODULE_3__/* .fetchBalanceNftInMarket */ .Ac)(result));
                            return [
                                3,
                                3
                            ];
                        case 2:
                            e = _state.sent();
                            console.log(e);
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function getNftBalanceInMarket() {
                return _ref.apply(this, arguments);
            };
        }();
        getNftBalanceInMarket();
    }, [
        chainId,
        dispatch
    ]);
    return [
        nftBalance,
        nftPrice
    ];
};
var GetDataUser = function(account, chainId) {
    var marketMultiBuy = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(function(state) {
        return state.marketMultiBuy;
    });
    var dataUser = marketMultiBuy.dataUser;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useDispatch */ .I0)();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var getDataUser = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
                var result, e;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                (0,___WEBPACK_IMPORTED_MODULE_2__/* .fetchAllowanceMarketMultiBuy */ .vX)(account, chainId)
                            ];
                        case 1:
                            result = _state.sent();
                            dispatch((0,_actions__WEBPACK_IMPORTED_MODULE_3__/* .fetchDataUser */ .fL)(result));
                            return [
                                3,
                                3
                            ];
                        case 2:
                            e = _state.sent();
                            console.log(e);
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function getDataUser() {
                return _ref.apply(this, arguments);
            };
        }();
        getDataUser();
    }, [
        dispatch,
        account
    ]);
    return [
        dataUser
    ];
};
var GetTotalBoxUserBuy = function(account, chainId) {
    var marketMultiBuy = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(function(state) {
        return state.marketMultiBuy;
    });
    var totalBoxUserBuy = marketMultiBuy.totalBoxOfUser;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useDispatch */ .I0)();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var getTotalBoxUserBuy = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
                var result, e;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                (0,___WEBPACK_IMPORTED_MODULE_2__/* .fetchTotalBoxOfUser */ .ne)(account, chainId)
                            ];
                        case 1:
                            result = _state.sent();
                            dispatch((0,_actions__WEBPACK_IMPORTED_MODULE_3__/* .fetchTotalBoxofUserBuy */ .Kj)(result));
                            return [
                                3,
                                3
                            ];
                        case 2:
                            e = _state.sent();
                            console.log(e);
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function getTotalBoxUserBuy() {
                return _ref.apply(this, arguments);
            };
        }();
        getTotalBoxUserBuy();
    }, [
        dispatch,
        account
    ]);
    return [
        totalBoxUserBuy
    ];
};
var GetBoxBuyOfUser = function(account, chainId) {
    var marketMultiBuy = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(function(state) {
        return state.marketMultiBuy;
    });
    var listBoxByUser = marketMultiBuy.listBoxByUser;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useDispatch */ .I0)();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var getListUserBuyBox = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
                var result, e;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                (0,___WEBPACK_IMPORTED_MODULE_2__/* .fetchUserBuyBox */ .bY)(account, chainId)
                            ];
                        case 1:
                            result = _state.sent();
                            dispatch((0,_actions__WEBPACK_IMPORTED_MODULE_3__/* .fetchAMountListBoxByUser */ .zG)(result));
                            return [
                                3,
                                3
                            ];
                        case 2:
                            e = _state.sent();
                            console.log(e);
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function getListUserBuyBox() {
                return _ref.apply(this, arguments);
            };
        }();
        getListUserBuyBox();
    }, [
        dispatch,
        account,
        chainId
    ]);
    return [
        listBoxByUser
    ];
};
var GetMaxNftTransfer = function(chainId) {
    var marketMultiBuy = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(function(state) {
        return state.marketMultiBuy;
    });
    var maxNftTransfer = marketMultiBuy.maxNftTransfer;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useDispatch */ .I0)();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var getNftTransfer = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
                var result, e;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                (0,___WEBPACK_IMPORTED_MODULE_2__/* .fetchNftTransfer */ .TC)(chainId)
                            ];
                        case 1:
                            result = _state.sent();
                            dispatch((0,_actions__WEBPACK_IMPORTED_MODULE_3__/* .fetchMaxNftTransfer */ .c2)(result));
                            return [
                                3,
                                3
                            ];
                        case 2:
                            e = _state.sent();
                            console.log(e);
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function getNftTransfer() {
                return _ref.apply(this, arguments);
            };
        }();
        getNftTransfer();
    }, [
        dispatch
    ]);
    return [
        maxNftTransfer
    ];
};


/***/ }),

/***/ 87057:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ae": function() { return /* binding */ fetchBalanceNftInMarkeMultiBuy; },
/* harmony export */   "TC": function() { return /* binding */ fetchNftTransfer; },
/* harmony export */   "bY": function() { return /* binding */ fetchUserBuyBox; },
/* harmony export */   "ne": function() { return /* binding */ fetchTotalBoxOfUser; },
/* harmony export */   "vX": function() { return /* binding */ fetchAllowanceMarketMultiBuy; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(97582);
/* harmony import */ var bignumber_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70794);
/* harmony import */ var config_constants_contracts__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87338);
/* harmony import */ var utils_addressHelpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69352);
/* harmony import */ var config_abi_multiBuyBox_json__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97427);
/* harmony import */ var utils_multicall__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9796);
/* harmony import */ var config_abi_erc20__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(56309);
/* harmony import */ var hooks_useRenderTokenByChain__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(83797);










var fetchBalanceNftInMarkeMultiBuy = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function(chainId) {
        var contractAddress, callsBalance, callsPrice, index, resultBalance, resultPrice, e;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    contractAddress = (0,utils_addressHelpers__WEBPACK_IMPORTED_MODULE_2__/* .getAddress */ .Kn)(config_constants_contracts__WEBPACK_IMPORTED_MODULE_1__/* ["default"].runMarketplaceMultiByBox */ .Z.runMarketplaceMultiByBox, chainId) || "";
                    if (!contractAddress.length) return [
                        3,
                        6
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    callsBalance = [];
                    callsPrice = [];
                    for(index = 1; index <= 4; index++){
                        callsBalance.push({
                            address: (0,utils_addressHelpers__WEBPACK_IMPORTED_MODULE_2__/* .getAddress */ .Kn)(config_constants_contracts__WEBPACK_IMPORTED_MODULE_1__/* ["default"].runMarketplaceMultiByBox */ .Z.runMarketplaceMultiByBox, chainId),
                            name: "runTogetherBoxNftTypeCountMap",
                            params: [
                                index
                            ]
                        });
                        callsPrice.push({
                            address: (0,utils_addressHelpers__WEBPACK_IMPORTED_MODULE_2__/* .getAddress */ .Kn)(config_constants_contracts__WEBPACK_IMPORTED_MODULE_1__/* ["default"].runMarketplaceMultiByBox */ .Z.runMarketplaceMultiByBox, chainId),
                            name: "runTogetherBoxNftTypePriceMap",
                            params: [
                                index
                            ]
                        });
                    }
                    return [
                        4,
                        (0,utils_multicall__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(config_abi_multiBuyBox_json__WEBPACK_IMPORTED_MODULE_3__, callsBalance, chainId)
                    ];
                case 2:
                    resultBalance = _state.sent();
                    return [
                        4,
                        (0,utils_multicall__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(config_abi_multiBuyBox_json__WEBPACK_IMPORTED_MODULE_3__, callsPrice, chainId)
                    ];
                case 3:
                    resultPrice = _state.sent();
                    return [
                        2,
                        {
                            nftInfo: {
                                nftBalance: {
                                    totalNftMetaRush: Number(new bignumber_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z(resultBalance[0].toString())),
                                    totalNftMetaRun: Number(new bignumber_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z(resultBalance[1].toString())),
                                    totalNftMetaRace: Number(new bignumber_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z(resultBalance[2].toString())),
                                    totalNftMetaRich: Number(new bignumber_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z(resultBalance[3].toString()))
                                },
                                nftPrice: {
                                    totalNftMetaRush: Number(new bignumber_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z(resultPrice[0].toString()).dividedBy(1E18)),
                                    totalNftMetaRun: Number(new bignumber_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z(resultPrice[1].toString()).dividedBy(1E18)),
                                    totalNftMetaRace: Number(new bignumber_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z(resultPrice[2].toString()).dividedBy(1E18)),
                                    totalNftMetaRich: Number(new bignumber_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z(resultPrice[3].toString()).dividedBy(1E18))
                                }
                            }
                        }
                    ];
                case 4:
                    e = _state.sent();
                    console.log(e);
                    return [
                        2,
                        {
                            nftInfo: {
                                nftBalance: {
                                    totalNftMetaRush: 0,
                                    totalNftMetaRun: 0,
                                    totalNftMetaRace: 0,
                                    totalNftMetaRich: 0
                                },
                                nftPrice: {
                                    totalNftMetaRush: 0,
                                    totalNftMetaRun: 0,
                                    totalNftMetaRace: 0,
                                    totalNftMetaRich: 0
                                }
                            }
                        }
                    ];
                case 5:
                    return [
                        3,
                        7
                    ];
                case 6:
                    return [
                        2,
                        {
                            nftInfo: {
                                nftBalance: {
                                    totalNftMetaRush: 0,
                                    totalNftMetaRun: 0,
                                    totalNftMetaRace: 0,
                                    totalNftMetaRich: 0
                                },
                                nftPrice: {
                                    totalNftMetaRush: 0,
                                    totalNftMetaRun: 0,
                                    totalNftMetaRace: 0,
                                    totalNftMetaRich: 0
                                }
                            }
                        }
                    ];
                case 7:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchBalanceNftInMarkeMultiBuy(chainId) {
        return _ref.apply(this, arguments);
    };
}();
var fetchTotalBoxOfUser = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function(account, chainId) {
        var contractAddress, calls, ref, resultTotalBoxOfUser, e;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    contractAddress = (0,utils_addressHelpers__WEBPACK_IMPORTED_MODULE_2__/* .getAddress */ .Kn)(config_constants_contracts__WEBPACK_IMPORTED_MODULE_1__/* ["default"].runMarketplaceMultiByBox */ .Z.runMarketplaceMultiByBox, chainId) || "";
                    if (!(account && contractAddress.length)) return [
                        3,
                        5
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    calls = [
                        {
                            address: (0,utils_addressHelpers__WEBPACK_IMPORTED_MODULE_2__/* .getAddress */ .Kn)(config_constants_contracts__WEBPACK_IMPORTED_MODULE_1__/* ["default"].runMarketplaceMultiByBox */ .Z.runMarketplaceMultiByBox, chainId),
                            name: "totalBoxOfUser",
                            params: [
                                account
                            ]
                        }
                    ];
                    return [
                        4,
                        (0,utils_multicall__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(config_abi_multiBuyBox_json__WEBPACK_IMPORTED_MODULE_3__, calls, chainId)
                    ];
                case 2:
                    ref = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"].apply */ .Z.apply(void 0, [
                        _state.sent(),
                        1
                    ]), resultTotalBoxOfUser = ref[0];
                    return [
                        2,
                        {
                            totalBoxOfUser: Number(new bignumber_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z(resultTotalBoxOfUser.toString()))
                        }
                    ];
                case 3:
                    e = _state.sent();
                    console.log(e);
                    return [
                        2,
                        {
                            totalBoxOfUser: 0
                        }
                    ];
                case 4:
                    return [
                        3,
                        6
                    ];
                case 5:
                    return [
                        2,
                        {
                            totalBoxOfUser: 0
                        }
                    ];
                case 6:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchTotalBoxOfUser(account, chainId) {
        return _ref.apply(this, arguments);
    };
}();
var fetchUserBuyBox = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function(account, chainId) {
        var contractAddress, calls, index, resultlistBox, e;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    contractAddress = (0,utils_addressHelpers__WEBPACK_IMPORTED_MODULE_2__/* .getAddress */ .Kn)(config_constants_contracts__WEBPACK_IMPORTED_MODULE_1__/* ["default"].runMarketplaceMultiByBox */ .Z.runMarketplaceMultiByBox, chainId) || "";
                    if (!(account && contractAddress.length)) return [
                        3,
                        5
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    calls = [];
                    for(index = 1; index <= 4; index++){
                        calls.push({
                            address: (0,utils_addressHelpers__WEBPACK_IMPORTED_MODULE_2__/* .getAddress */ .Kn)(config_constants_contracts__WEBPACK_IMPORTED_MODULE_1__/* ["default"].runMarketplaceMultiByBox */ .Z.runMarketplaceMultiByBox, chainId),
                            name: "userBoxTypeMap",
                            params: [
                                account,
                                index
                            ]
                        });
                    }
                    return [
                        4,
                        (0,utils_multicall__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(config_abi_multiBuyBox_json__WEBPACK_IMPORTED_MODULE_3__, calls, chainId)
                    ];
                case 2:
                    resultlistBox = _state.sent();
                    return [
                        2,
                        {
                            listBoxByUser: {
                                totalBoxMetaRush: Number(new bignumber_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z(resultlistBox[0].toString())),
                                totalBoxMetaRun: Number(new bignumber_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z(resultlistBox[1].toString())),
                                totalBoxMetaRace: Number(new bignumber_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z(resultlistBox[2].toString())),
                                totalBoxMetaRich: Number(new bignumber_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z(resultlistBox[3].toString()))
                            }
                        }
                    ];
                case 3:
                    e = _state.sent();
                    console.log(e);
                    return [
                        2,
                        {
                            listBoxByUser: {
                                totalBoxMetaRush: 0,
                                totalBoxMetaRun: 0,
                                totalBoxMetaRace: 0,
                                totalBoxMetaRich: 0
                            }
                        }
                    ];
                case 4:
                    return [
                        3,
                        6
                    ];
                case 5:
                    return [
                        2,
                        {
                            listBoxByUser: {
                                totalBoxMetaRush: 0,
                                totalBoxMetaRun: 0,
                                totalBoxMetaRace: 0,
                                totalBoxMetaRich: 0
                            }
                        }
                    ];
                case 6:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchUserBuyBox(account, chainId) {
        return _ref.apply(this, arguments);
    };
}();
var fetchNftTransfer = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function(chainId) {
        var contractAddress, calls, ref, resultNftTransfer, e;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    contractAddress = (0,utils_addressHelpers__WEBPACK_IMPORTED_MODULE_2__/* .getAddress */ .Kn)(config_constants_contracts__WEBPACK_IMPORTED_MODULE_1__/* ["default"].runMarketplaceMultiByBox */ .Z.runMarketplaceMultiByBox, chainId) || "";
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    calls = [
                        {
                            address: contractAddress,
                            name: "maxNftInTransfer",
                            params: []
                        }
                    ];
                    return [
                        4,
                        (0,utils_multicall__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(config_abi_multiBuyBox_json__WEBPACK_IMPORTED_MODULE_3__, calls, chainId)
                    ];
                case 2:
                    ref = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"].apply */ .Z.apply(void 0, [
                        _state.sent(),
                        1
                    ]), resultNftTransfer = ref[0];
                    return [
                        2,
                        {
                            maxNftTransfer: Number(new bignumber_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z(resultNftTransfer.toString()))
                        }
                    ];
                case 3:
                    e = _state.sent();
                    console.log(e);
                    return [
                        2,
                        {
                            maxNftTransfer: 0
                        }
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchNftTransfer(chainId) {
        return _ref.apply(this, arguments);
    };
}();
var fetchAllowanceMarketMultiBuy = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function(account, chainId) {
        var contractMultiBuyAddress, tokenAddress, calls, ref, resultAllowance, resultBalanceOf, e;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    contractMultiBuyAddress = (0,utils_addressHelpers__WEBPACK_IMPORTED_MODULE_2__/* .getAddress */ .Kn)(config_constants_contracts__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z === null || config_constants_contracts__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z === void 0 ? void 0 : config_constants_contracts__WEBPACK_IMPORTED_MODULE_1__/* ["default"].runMarketplaceMultiByBox */ .Z.runMarketplaceMultiByBox, chainId);
                    if (!(account && (contractMultiBuyAddress === null || contractMultiBuyAddress === void 0 ? void 0 : contractMultiBuyAddress.length))) return [
                        3,
                        5
                    ];
                    tokenAddress = (0,hooks_useRenderTokenByChain__WEBPACK_IMPORTED_MODULE_6__/* .renderTokenBUSDByChain */ .qF)(chainId);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    calls = [
                        {
                            address: tokenAddress,
                            name: "allowance",
                            params: [
                                account,
                                contractMultiBuyAddress
                            ]
                        },
                        {
                            address: tokenAddress,
                            name: "balanceOf",
                            params: [
                                account
                            ]
                        }
                    ];
                    return [
                        4,
                        (0,utils_multicall__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(config_abi_erc20__WEBPACK_IMPORTED_MODULE_5__/* .ERC20_ABI */ .RB, calls, chainId)
                    ];
                case 2:
                    ref = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"].apply */ .Z.apply(void 0, [
                        _state.sent(),
                        2
                    ]), resultAllowance = ref[0], resultBalanceOf = ref[1];
                    return [
                        2,
                        {
                            dataUser: {
                                balanceOf: new bignumber_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z(resultBalanceOf.toString()).dividedBy(1E18).toString(),
                                allowance: new bignumber_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z(resultAllowance.toString()).dividedBy(1E18).toString()
                            }
                        }
                    ];
                case 3:
                    e = _state.sent();
                    console.log(e);
                    return [
                        2,
                        {
                            dataUser: {
                                balanceOf: "0",
                                allowance: "0"
                            }
                        }
                    ];
                case 4:
                    return [
                        3,
                        6
                    ];
                case 5:
                    return [
                        2,
                        {
                            dataUser: {
                                balanceOf: "0",
                                allowance: "0"
                            }
                        }
                    ];
                case 6:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchAllowanceMarketMultiBuy(account, chainId) {
        return _ref.apply(this, arguments);
    };
}();


/***/ })

}]);